import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";

const PurchaseLedgerReport = () => {
   const today = new Date().toISOString().split('T')[0];
  const [reportDate, setReportDate] = useState(today);
  const [purchase, setPurchases] = useState([]);
  console.log("purchase",purchase)

  const handleFetchData = async () => {
    try {
      const res = await axios.post("https://api.trucoo.in/ledger/master-ledger/", {
        date: reportDate
      }, {
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": "erpTrucoo"
        }
      });

      if (res.data.status === 'success') {
        setPurchases(res.data.purchases || []);
      }
    } catch (err) {
      console.error("Error fetching ledger summary:", err.message);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, [reportDate]);


  const totalAmt = purchase.reduce((sum, purchase) => sum + parseFloat(purchase.totalAmount), 0);
  const totalgst = purchase.reduce((sum, purchase) => sum + parseFloat(purchase.gst), 0);
  const grandTotal = purchase.reduce((sum, purchase) => sum + parseFloat(purchase.grandTotal), 0);

  const getFiscalYearLabel = (date = new Date()) => {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
  };

  const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
  };
  return (
    <>
      <Header />
      <Sidebar />
        <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <div className="row mt-3">
                  <div className="col-md-3"><h4 className="box-title">Purchase Ledger</h4></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3">
                    <input
                      type="date"
                      className="form-control"
                      value={reportDate}
                      onChange={(e) => setReportDate(e.target.value)}
                    />
                  </div>               
                </div>
              </div>
              <div className="box-body">
                <div className="table-responsive">
                  <table className="table-sm table-bordered fs-12" width="100%">
                    <thead className="thead-light">
                      <tr>
                        <th width="3%" className="text-center">S.No</th>
                        <th width="8%" className="text-center">Date</th>
                        <th width="10%" className="text-center">Invoice No</th>                        
                        <th className="text-center">Vender</th>
                        <th width="8%" className="text-center">Item</th>
                        <th width="8%" className="text-center">Quantity</th>
                        <th width="10%" className="text-center">Total Amount</th>
                        <th width="10%" className="text-center">GST Amount</th>
                        <th width="10%" className="text-center">Grand Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {purchase.length > 0 ? (
                        <>
                          {purchase.map((purchase, index) => (
                            <tr key={`invoice-${index}`}>
                              <td>{index + 1}</td>
                              <td>{formatViewDate(purchase.date)}</td>
                              <td>{`TRC/${purchase?.invoiceId}/${getFiscalYearLabel(new Date(purchase?.date))}`}</td>
                              <td>{purchase.vender || 'N/A'}</td>
                              <td>{purchase.item}</td>
                              <td>{purchase.quantity}</td>
                              <td className="text-end">{Number(purchase.totalAmount).toFixed(2)}</td>
                              <td className="text-end">{Number(purchase.gst).toFixed(2)}</td>
                              <td className="text-end">{Number(purchase.grandTotal).toFixed(2)}</td>
                            </tr>
                          ))}
                          <tr>
                            <th colSpan="6" className="text-right">Total</th>
                            <th className="text-end">{totalAmt.toFixed(2)}</th>
                            <th className="text-end">{totalgst.toFixed(2)}</th>
                            <th className="text-end">{grandTotal.toFixed(2)}</th>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">No invoices with GST found for this date.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default PurchaseLedgerReport;